import React from 'react'
import { useNavigate } from 'react-router-dom';

const Logo = () => {
    const Navigate = useNavigate();
    return (
        <header className="flex flex-col items-start w-full cursor-pointer" onClick={() => Navigate('/')}>
            <div
                className="bg-[#1d1d1d] rounded-xl px-6 py-4 inline-flex items-end justify-center shadow-sm"
                role="img"
                aria-label="InstaED logo"
            >
                <span className="text-white text-2rem sm:text-3xl italic font-srisakdi">Insta</span>
                <span className="text-white text-5xl sm:text-6xl font-black leading-none">ED</span>
            </div>
            <p className="mt-3 text-[#2c2c2c] text-base sm:text-lg tracking-wide font-medium">
                Online Tuitions | 6–12
            </p>
        </header>
    )
}

export default Logo
